import omit from "lodash/omit"
import { styled, StyleProps } from "../../styles"
import { getButtonCss, BaseButtonProps } from "../../Button/ButtonStyles"

interface StyledRadioButtonProps extends Omit<BaseButtonProps, "style"> {
  checked: `checked` | `unchecked`
}

type Props = StyledRadioButtonProps & StyleProps

const StyledRadioButton = styled.button<StyledRadioButtonProps>((props: Props) => ({
  ...getButtonCss(omit(props, `style`)),
  width: 140,
  height: 62,
  border:
    props.checked === `checked`
      ? `3px solid ${props.theme.palette.brand}`
      : `1px solid ${props.theme.palette.grey.dark}`,
  alignItems: `center`,
  justifyContent: `center`,
  position: `relative`,
  "&:not(:last-child)": {
    marginRight: props.theme.spacing(6),
  },
}))

export default StyledRadioButton
